import { ref } from 'vue'
import { getMe } from '@api'
import type { Me } from '@types'

export const meStore = ref<Me | null>(null)

export const get_me = async (): Promise<Me | null> => {
  const me = await getMe()
  meStore.value = me
  return me
}
